import template from './form.html';
import detalleTemplate from './detalle.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import notasCreditoI18N from 'i18n/notas-credito/es.json';
import commonI18N from 'i18n/common/es.json';
import { notEmpty, pad, fechaRenderer } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let NotaCreditoForm = {
  templateUrl: template,
  selector: 'notaCreditoForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(notasCreditoI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$scope', '$filter', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', 'localStorageService', 'CustomModal'
];

function FormController($state, $scope, $filter, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, localStorageService, CustomModal) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);

  this.loadClientes = loadClientes.bind(this);

  this.renderCliente = renderCliente.bind(this);
  this.renderMontoDetalle = renderMontoDetalle.bind(this);

  this.notEmpty = notEmpty.bind(this);

  this.setTotales = setTotales.bind(this);
  this.removerDetalle = removerDetalle.bind(this);
  this.updateTotales = updateTotales.bind(this);
  this.modificarDetalle = modificarDetalle.bind(this);


  this.renderTipoComprobante = renderTipoComprobante.bind(this);
  this.onSelectTipoComprobante = onSelectTipoComprobante.bind(this);

  this.cancel = cancel.bind(this);

  const valoresFilter = Filter.path('tipo.codigo').eq('estado_nota_credito');
  const valorMinimoMonedaFilter = Filter.path('codigo').eq('valor_minimo_moneda');



  let unsubscribe;
  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.timbradosVigentes.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    ngNotify.dismiss();
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(valorMinimoMonedaFilter)})) ;

    let caja = localStorageService.get('caja');
    if (!caja) {
      ngNotify.set(this.translations['Debe asignar una caja al equipo'], 'warn');
      $state.go('home.notas-credito.list');
      return;
    } else if (caja.sesionActual && caja.sesionActual.estado.value !== 'Abierta') {
      ngNotify.set(this.translations['Debe abrir la caja para cobrar'], 'warn');
      $state.go('home.notas-credito.list');
      return;
    }

    if ($stateParams.fid) {
      this.title = this.translations['Nota de credito a partir de Factura'];
      this.formEdit('facturas', $stateParams.fid);
      $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));
      $ngRedux.dispatch(rest.actions.timbradosVigentes({}, {
        body: JSON.stringify({
          puntoEmisionId: caja.puntoEmision.id,
          sesionCajaId: caja.sesionActual.id,
          cajaId: caja.id,
          tipos: ['Nota de Crédito']
        })
      }));
      this.creacion = true;
    } else if ($stateParams.uid) {
      this.title = this.translations['Ver nota de credito'];
      this.formEdit('notas-credito', $stateParams.uid);
      this.creacion = false;
    } else {
      $state.go('home.notas-credito.list');
      return;
    }
  };


  this.localModel = {
    totalServicios: $filter('currency')(0, 'Gs.', 0),
    totalProductos: $filter('currency')(0, 'Gs.', 0),
    total: $filter('currency')(0, 'Gs.', 0),
    totalNC: $filter('currency')(0, 'Gs.', 0),
    detalles: {},
    new: {
      fecha: fechaRenderer(new Date())
    },
    nuevoDetalle: {},
    totalDetalles: 0
  };

  this.submitted = false;

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.model = state.form.model;

    if (this.creacion) {
      this.factura = state.form.model;
    }

    if (!this.modelInit && this.model.id) {
      this.modelInit = true;
      this.setTotales();
      this.localModel.new.cliente = this.model.cliente;

      this.localModel.timbradoDetalle = `${this.model.tipoComprobante.nombre} (${this.model.tipoComprobante.clase.name} / ${this.model.timbradoDetalle.cabecera.claseTimbrado.name} )`;

      this.localModel.cliente = this.renderCliente(this.model.cliente, true);
      this.localModel.servicios = this.model.detalles.filter(v => v.codigo);
      this.localModel.productos = this.model.detalles.filter(v => v.producto);
    }

    if (state.formasPago.data.length && !this.formaPagoDefault) {
      this.formaPagoDefault = state.formasPago.data.filter(v => v.formaDesembolso.value === 'Efectivo')[0];
      this.localModel.nuevoDetalle.formaPago = this.formaPagoDefault;
    }

    if (state.formasPago.data.length && !this.formaPagoDefault) {
      this.formaPagoDefault = state.formasPago.data.filter(v => v.formaDesembolso.value === 'Efectivo')[0];
      this.localModel.nuevoDetalle.formaPago = this.formaPagoDefault;
    }



    if (!this.view && this.creacion && state.valores.data && state.valores.data.length > 0 &&
      state.timbradosVigentes.data && state.timbradosVigentes.data.length > 0) {
      this.estados = state.valores.data.filter(v => v.tipo.codigo === 'estado_nota_credito');
      let estadoCreado = this.estados.filter(v => v.value === 'Emitida')[0];

      this.localModel.new.estado = estadoCreado;

      let timbradoDefault = state.timbradosVigentes.data.filter(v => v.tipoComprobanteDefault) || [];
      if (timbradoDefault.length) {
        this.localModel.new.timbradoDetalle = timbradoDefault[0];
        this.onSelectTipoComprobante();
      } else if (state.timbradosVigentes.data.length === 1) {
        this.localModel.new.timbradoDetalle = state.timbradosVigentes.data[0];
        this.onSelectTipoComprobante();
      }
    }


    return {
      form: state.form,
      timbradosVigentes: state.timbradosVigentes.data,
      valorMinimoMoneda: state.parametros.data.filter((v) => v.codigo === 'valor_minimo_moneda')[0]
    };
  }

  function setTotales() {
    let totalServicios = 0;
    let totalProductos = 0;

    this.model.detalles.forEach(function(detalle) {
      if (detalle.producto) {
        totalProductos += detalle.precio - detalle.descuento;
      } else {
        totalServicios += detalle.precio;
      }
      let cantidadNC = 0;
      if (detalle.notaCreditoDetalles) {
        detalle.notaCreditoDetalles.forEach(function(nota) {
          cantidadNC += nota.cantidad;
        });
      }
      detalle.precioUnitario = detalle.precio / detalle.cantidad;
      detalle.restante = detalle.cantidad - cantidadNC;
      detalle.cantidadNC = cantidadNC;
    });

    this.localModel.totalServicios = $filter('currency')(totalServicios, 'Gs.', 0);
    this.localModel.totalProductos = $filter('currency')(totalProductos, 'Gs.', 0);
    this.localModel.totalFactura = totalServicios + totalProductos;
    if (this.view)
      this.localModel.totalNC = $filter('currency')(this.model.total, 'Gs.', 0);

  }

  function renderMontoDetalle(notaDetalle) {
    let precio = notaDetalle.descuento ? notaDetalle.precio - notaDetalle.descuento : notaDetalle.precio;
    return $filter('currency')(precio, 'Gs.', 0);
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.notas-credito.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      this.notaCreditoNotify(state.form.created);
      $state.go('home.notas-credito.list');
    }
  }

  function onSelectTipoComprobante() {
    this.localModel.new.numeroTimbrado = this.localModel.new.timbradoDetalle.cabecera.numero;
    this.localModel.new.numeroComprobante = `${pad(this.localModel.new.timbradoDetalle.sucursalNumero, 3)}-${pad(this.localModel.new.timbradoDetalle.puntoEmision.codigo, 3)}-${pad(this.localModel.new.timbradoDetalle.ultimaNumeracion, 7)}`;
  }

  function doSubmit() {
    if ($scope.form.$invalid) {
      this.submitted = true;
      return;
    }

    if (!Object.keys(this.localModel.detalles).length) {
      ngNotify.set(this.translations['Debe incluir un detalle a la Nota de Credito'], 'warn');
      return;
    }

    let caja = localStorageService.get('caja');
    let self = this;

    let payload = Object.assign({
      sesionCajaId: caja.sesionActual.id,
      factura: { id: this.model.id }
    }, this.localModel.new);

    payload.detalles = [];
    Object.keys(this.localModel.detalles).forEach(function(key) {
      payload.detalles.push(self.localModel.detalles[key]);
    });

    $ngRedux.dispatch(rest.actions.notasCredito.post({}, {
      body: JSON.stringify(payload)
    }, (err, data) => {
      if (!err && data && data.length === 1 && data[0].estado.value == 'Emitida') {
        ngNotify.set(self.translations['Comprobante Emitido'], 'success');
        $state.go('home.notas-credito.list');
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }
    }));
  }


  function modificarDetalle(detalle) {
    let self = this;

    let payload = this.localModel.detalles[detalle.id] || {
      cantidad: 1,
      descripcion: detalle.descripcion,
      facturaDetalle: { id: detalle.id },
      importe: detalle.precioUnitario
    };

    let options = {
      title: 'Detalle de la Factura',
      templateUrl: detalleTemplate,
      vm: this,
      detalle,
      payload,
      ok: function() {
        if (options.scope.$$childHead.form.$invalid) {
          return false;
        }
        self.localModel.detalles[detalle.id] = payload;
        self.localModel.detalles[detalle.id].importe = (detalle.precioUnitario - (detalle.descuento / detalle.cantidad)) * self.localModel.detalles[detalle.id].cantidad;
        self.updateTotales();
      }
    };
    CustomModal.open(options);
  }

  function removerDetalle(detalle) {
    delete this.localModel.detalles[detalle.id];
    this.updateTotales();
  }

  function updateTotales() {
    let total = 0;
    let cantDetalles = 0;
    let detalles = this.localModel.detalles;
    let cantTotalProductos = 0;
    let porcentajeDesc = 0;

    this.model.detalles.forEach(function(detalle) {
      cantTotalProductos += detalle.cantidad;
    });

    if(this.model.formaPagoDescuento){
      porcentajeDesc = this.model.formaPagoDescuento.porcentajeDescuento;
    }

    Object.keys(this.localModel.detalles).forEach(function(key) {
      total += detalles[key].importe - ((detalles[key].importe * porcentajeDesc)/100);
      cantDetalles+=detalles[key].cantidad;
    });
    if(this.valorMinimoMoneda.valor.value!=0){
      total = total - (total % this.valorMinimoMoneda.valor.value);
    }
    
    this.localModel.totalNC = $filter('currency')(total, 'Gs.', 0);
  }


  function deleteDetalle(detalle) {
    _.remove(this.localModel.detalles, detalle);
    this.updateTotales();
  }


  function renderTipoComprobante(timbradoDetalle) {
    return `${timbradoDetalle.tipoComprobante.nombre} (${timbradoDetalle.tipoComprobante.clase.name} / ${timbradoDetalle.cabecera.claseTimbrado.name} )`;
  }

  function renderCliente(cliente, plain) {
    let numeroDoc = cliente.numeroDocumento ? cliente.numeroDocumento : 'Sin Nro. Documento';
    let detalle = plain ? `(${numeroDoc})` : `<small><strong>(${numeroDoc})</strong></small>`;

    return `${cliente.razonSocial} ${detalle}`;
  }


  function cancel() {
    if (this.creacion)
      $state.go('home.facturas.list');
    else
      $state.go('home.notas-credito.list');
  }

  function loadClientes(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numeroDocumento').like(query))
        .or(Filter.path('tipoDocumento.value').like(query))
        .or(Filter.path('sexo.value').like(query))
        .or(Filter.path('telefono').like(query)));
    }
    BasicFactory.setup('clientes');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }
}


// WEBPACK FOOTER //
// ./src/components/notas-credito/form/form.component.js